var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "holder" }, [
      _c(
        "h2",
        { attrs: { id: "page-header" } },
        [
          _c("router-link", { attrs: { to: "/" } }, [_vm._v("My Arlington -")]),
          _c("router-link", { attrs: { to: "/foodResources" } }, [
            _vm._v(" Food Assistance Resources")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0)
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "layer-page" }, [
      _c("div", { staticClass: "widget one-third filter-pane" }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isMobile || _vm.mobileMenu === false,
                expression: "isMobile || mobileMenu === false"
              }
            ],
            staticClass: "filter-header",
            attrs: {
              type: "button",
              id: "mobile-menu",
              "aria-expanded": _vm.mobileMenu ? "true" : "false",
              "aria-controls": "filters-and-settings"
            },
            on: {
              click: function($event) {
                _vm.mobileMenu = !_vm.mobileMenu
              }
            }
          },
          [
            _vm._v("\n                Filters and Location\n                "),
            _c(
              "svg",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.mobileMenu,
                    expression: "!mobileMenu"
                  }
                ],
                staticClass: "icon",
                staticStyle: { float: "right" },
                attrs: { "aria-hidden": "true", focusable: "false" }
              },
              [_c("use", { attrs: { "xlink:href": "#icon-plus" } })]
            ),
            _vm._v(" "),
            _c(
              "svg",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.mobileMenu,
                    expression: "mobileMenu"
                  }
                ],
                staticClass: "icon",
                staticStyle: { float: "right" },
                attrs: { "aria-hidden": "true", focusable: "false" }
              },
              [_c("use", { attrs: { "xlink:href": "#icon-minus" } })]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isMobile || _vm.mobileMenu,
                expression: "!isMobile || mobileMenu"
              }
            ],
            attrs: { id: "filters-and-settings" }
          },
          [
            _c("div", { staticClass: "filter-container" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isMobile,
                      expression: "!isMobile"
                    }
                  ],
                  staticClass: "filter-header",
                  attrs: {
                    type: "button",
                    "aria-expanded": _vm.filtersExpanded ? "true" : "false",
                    "aria-controls": "food-resources-filter-panels"
                  },
                  on: { click: _vm.filtersToggle }
                },
                [
                  _c("span", [
                    _vm._v("Filters\n                            "),
                    _c(
                      "svg",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.filtersExpanded,
                            expression: "filtersExpanded"
                          }
                        ],
                        staticClass: "icon",
                        staticStyle: { float: "right" },
                        attrs: { "aria-hidden": "true", focusable: "false" }
                      },
                      [_c("use", { attrs: { "xlink:href": "#icon-minus" } })]
                    ),
                    _vm._v(" "),
                    _c(
                      "svg",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.filtersExpanded,
                            expression: "!filtersExpanded"
                          }
                        ],
                        staticClass: "icon",
                        staticStyle: { float: "right" },
                        attrs: { "aria-hidden": "true", focusable: "false" }
                      },
                      [_c("use", { attrs: { "xlink:href": "#icon-plus" } })]
                    ),
                    _vm._v(" "),
                    _c("span", {
                      staticStyle: { clear: "both", display: "block" }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { attrs: { id: "food-resources-filter-panels" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.filtersExpanded || _vm.mobileMenu,
                        expression: "filtersExpanded || mobileMenu"
                      }
                    ],
                    staticClass: "filterList"
                  },
                  [
                    _c("br"),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item filter-category" }, [
                      _vm._v("Type")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.typeSelected,
                              expression: "typeSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "FOOD PANTRY",
                            checked: Array.isArray(_vm.typeSelected)
                              ? _vm._i(_vm.typeSelected, "FOOD PANTRY") > -1
                              : _vm.typeSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.typeSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "FOOD PANTRY",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.typeSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.typeSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.typeSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm._m(1),
                        _vm._v(" "),
                        _c("span", { staticClass: "icon" })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.typeSelected,
                              expression: "typeSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "SCHOOL MEALS",
                            checked: Array.isArray(_vm.typeSelected)
                              ? _vm._i(_vm.typeSelected, "SCHOOL MEALS") > -1
                              : _vm.typeSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.typeSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "SCHOOL MEALS",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.typeSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.typeSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.typeSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm._m(2)
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.typeSelected,
                              expression: "typeSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "PREPARED MEALS",
                            checked: Array.isArray(_vm.typeSelected)
                              ? _vm._i(_vm.typeSelected, "PREPARED MEALS") > -1
                              : _vm.typeSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.typeSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "PREPARED MEALS",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.typeSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.typeSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.typeSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm._m(3)
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.typeSelected,
                              expression: "typeSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "DISCOUNT GROCERIES",
                            checked: Array.isArray(_vm.typeSelected)
                              ? _vm._i(_vm.typeSelected, "DISCOUNT GROCERIES") >
                                -1
                              : _vm.typeSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.typeSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "DISCOUNT GROCERIES",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.typeSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.typeSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.typeSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm._m(4)
                      ])
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item filter-category" }, [
                      _vm._v("Eligibility Features")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterSelected,
                              expression: "filterSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "Eligibility Requirement",
                            checked: Array.isArray(_vm.filterSelected)
                              ? _vm._i(
                                  _vm.filterSelected,
                                  "Eligibility Requirement"
                                ) > -1
                              : _vm.filterSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.filterSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "Eligibility Requirement",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.filterSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.filterSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.filterSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip" }, [
                          _vm._v(" Eligibility requirement")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterSelected,
                              expression: "filterSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "No Photo ID Required",
                            checked: Array.isArray(_vm.filterSelected)
                              ? _vm._i(
                                  _vm.filterSelected,
                                  "No Photo ID Required"
                                ) > -1
                              : _vm.filterSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.filterSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "No Photo ID Required",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.filterSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.filterSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.filterSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip" }, [
                          _vm._v(" No Photo ID required")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterSelected,
                              expression: "filterSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "No Registration Required",
                            checked: Array.isArray(_vm.filterSelected)
                              ? _vm._i(
                                  _vm.filterSelected,
                                  "No Registration Required"
                                ) > -1
                              : _vm.filterSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.filterSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "No Registration Required",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.filterSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.filterSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.filterSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip" }, [
                          _vm._v(" No Registration required")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterSelected,
                              expression: "filterSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value:
                              "Restricted access (only members of these communities)",
                            checked: Array.isArray(_vm.filterSelected)
                              ? _vm._i(
                                  _vm.filterSelected,
                                  "Restricted access (only members of these communities)"
                                ) > -1
                              : _vm.filterSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.filterSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v =
                                    "Restricted access (only members of these communities)",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.filterSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.filterSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.filterSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm._m(5)
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterSelected,
                              expression: "filterSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "age_restriction",
                            checked: Array.isArray(_vm.filterSelected)
                              ? _vm._i(_vm.filterSelected, "age_restriction") >
                                -1
                              : _vm.filterSelected
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = _vm.filterSelected,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = "age_restriction",
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.filterSelected = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.filterSelected = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.filterSelected = $$c
                                }
                              },
                              function($event) {
                                return _vm.ageRestrictionChange($event)
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip" }, [
                          _vm._v(" Age restrictions")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.filterSelected.includes("age_restriction")
                      ? _c(
                          "div",
                          { staticClass: "filter-item filter-item-nested" },
                          [
                            _c(
                              "label",
                              { staticClass: "filter-checkbox-label" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.filterSelected,
                                      expression: "filterSelected"
                                    }
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    value:
                                      "Age restrictions - for children (or families of children) only",
                                    checked: Array.isArray(_vm.filterSelected)
                                      ? _vm._i(
                                          _vm.filterSelected,
                                          "Age restrictions - for children (or families of children) only"
                                        ) > -1
                                      : _vm.filterSelected
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.filterSelected,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v =
                                            "Age restrictions - for children (or families of children) only",
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.filterSelected = $$a.concat([
                                              $$v
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.filterSelected = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.filterSelected = $$c
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _vm._m(6)
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterSelected.includes("age_restriction")
                      ? _c(
                          "div",
                          { staticClass: "filter-item filter-item-nested" },
                          [
                            _c(
                              "label",
                              { staticClass: "filter-checkbox-label" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.filterSelected,
                                      expression: "filterSelected"
                                    }
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    value:
                                      "Age restrictions - for seniors only",
                                    checked: Array.isArray(_vm.filterSelected)
                                      ? _vm._i(
                                          _vm.filterSelected,
                                          "Age restrictions - for seniors only"
                                        ) > -1
                                      : _vm.filterSelected
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.filterSelected,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v =
                                            "Age restrictions - for seniors only",
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.filterSelected = $$a.concat([
                                              $$v
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.filterSelected = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.filterSelected = $$c
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _vm._m(7)
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterSelected,
                              expression: "filterSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "Income maximum for eligibility",
                            checked: Array.isArray(_vm.filterSelected)
                              ? _vm._i(
                                  _vm.filterSelected,
                                  "Income maximum for eligibility"
                                ) > -1
                              : _vm.filterSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.filterSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "Income maximum for eligibility",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.filterSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.filterSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.filterSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip" }, [
                          _vm._v(" Income maximum")
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.filtersExpanded || _vm.mobileMenu,
                        expression: "filtersExpanded || mobileMenu"
                      }
                    ],
                    staticClass: "filterList"
                  },
                  [
                    _c("br"),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item filter-category" }, [
                      _vm._v("Program Features")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterSelected,
                              expression: "filterSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "Delivery Available",
                            checked: Array.isArray(_vm.filterSelected)
                              ? _vm._i(
                                  _vm.filterSelected,
                                  "Delivery Available"
                                ) > -1
                              : _vm.filterSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.filterSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "Delivery Available",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.filterSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.filterSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.filterSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip" }, [
                          _vm._v(" Delivery Available")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterSelected,
                              expression: "filterSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "Prepared Meals",
                            checked: Array.isArray(_vm.filterSelected)
                              ? _vm._i(_vm.filterSelected, "Prepared Meals") >
                                -1
                              : _vm.filterSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.filterSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "Prepared Meals",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.filterSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.filterSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.filterSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip" }, [
                          _vm._v(" Prepared Meals")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterSelected,
                              expression: "filterSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "Grocery Items",
                            checked: Array.isArray(_vm.filterSelected)
                              ? _vm._i(_vm.filterSelected, "Grocery Items") > -1
                              : _vm.filterSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.filterSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "Grocery Items",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.filterSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.filterSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.filterSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip" }, [
                          _vm._v(" Grocery Items")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterSelected,
                              expression: "filterSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "Fresh Produce",
                            checked: Array.isArray(_vm.filterSelected)
                              ? _vm._i(_vm.filterSelected, "Fresh Produce") > -1
                              : _vm.filterSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.filterSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "Fresh Produce",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.filterSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.filterSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.filterSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip" }, [
                          _vm._v(" Fresh Produce")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterSelected,
                              expression: "filterSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "Accepts SNAP",
                            checked: Array.isArray(_vm.filterSelected)
                              ? _vm._i(_vm.filterSelected, "Accepts SNAP") > -1
                              : _vm.filterSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.filterSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "Accepts SNAP",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.filterSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.filterSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.filterSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip" }, [
                          _vm._v(" Accepts SNAP")
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.filtersExpanded || _vm.mobileMenu,
                        expression: "filtersExpanded || mobileMenu"
                      }
                    ],
                    staticClass: "filterList"
                  },
                  [
                    _c("br"),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item filter-category" }, [
                      _vm._v("Other Services Provided")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterSelected,
                              expression: "filterSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "Other services provided - Diapers",
                            checked: Array.isArray(_vm.filterSelected)
                              ? _vm._i(
                                  _vm.filterSelected,
                                  "Other services provided - Diapers"
                                ) > -1
                              : _vm.filterSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.filterSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "Other services provided - Diapers",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.filterSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.filterSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.filterSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip" }, [
                          _vm._v(" Diapers")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterSelected,
                              expression: "filterSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "Other services provided - Baby formula",
                            checked: Array.isArray(_vm.filterSelected)
                              ? _vm._i(
                                  _vm.filterSelected,
                                  "Other services provided - Baby formula"
                                ) > -1
                              : _vm.filterSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.filterSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v =
                                    "Other services provided - Baby formula",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.filterSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.filterSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.filterSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip" }, [
                          _vm._v(" Baby Formula")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterSelected,
                              expression: "filterSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value:
                              "Other services provided - Financial assistance",
                            checked: Array.isArray(_vm.filterSelected)
                              ? _vm._i(
                                  _vm.filterSelected,
                                  "Other services provided - Financial assistance"
                                ) > -1
                              : _vm.filterSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.filterSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v =
                                    "Other services provided - Financial assistance",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.filterSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.filterSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.filterSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip" }, [
                          _vm._v(" Financial Assistance")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterSelected,
                              expression: "filterSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "Other services provided - Clothing",
                            checked: Array.isArray(_vm.filterSelected)
                              ? _vm._i(
                                  _vm.filterSelected,
                                  "Other services provided - Clothing"
                                ) > -1
                              : _vm.filterSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.filterSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "Other services provided - Clothing",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.filterSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.filterSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.filterSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip" }, [
                          _vm._v(" Clothing")
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.filtersExpanded || _vm.mobileMenu,
                        expression: "filtersExpanded || mobileMenu"
                      }
                    ],
                    staticClass: "filterList"
                  },
                  [
                    _c("br"),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item filter-category" }, [
                      _vm._v("Public Transit")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.transitSelected,
                              expression: "transitSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "Bus",
                            checked: Array.isArray(_vm.transitSelected)
                              ? _vm._i(_vm.transitSelected, "Bus") > -1
                              : _vm.transitSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.transitSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "Bus",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.transitSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.transitSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.transitSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip" }, [
                          _vm._v("  Bus")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-item" }, [
                      _c("label", { staticClass: "filter-checkbox-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.transitSelected,
                              expression: "transitSelected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: "Metro",
                            checked: Array.isArray(_vm.transitSelected)
                              ? _vm._i(_vm.transitSelected, "Metro") > -1
                              : _vm.transitSelected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.transitSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "Metro",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.transitSelected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.transitSelected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.transitSelected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip" }, [
                          _vm._v("  Metro")
                        ])
                      ])
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("h3", [_vm._v("Zoom to Location")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-container zoom-container" },
                [
                  _c("label", { attrs: { for: "addressSearch" } }, [
                    _vm._v("Address")
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("gmap-autocomplete", {
                    ref: "autocomplete",
                    attrs: {
                      id: "addressSearch",
                      placeholder: "Enter street address"
                    },
                    on: { place_changed: _vm.placeChanged }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "filter-container" }, [
                _c(
                  "button",
                  {
                    staticClass: "link filter-header",
                    on: { click: _vm.clearAll }
                  },
                  [_vm._v("Clear All")]
                )
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "widget full-map-pane toggle-window two-thirds" },
        [
          _c("div", { staticStyle: { position: "relative", top: "0" } }, [
            _c(
              "div",
              {
                staticClass: "toggle-bar",
                attrs: { role: "group", "aria-label": "Map or list" }
              },
              [
                _c(
                  "button",
                  {
                    class:
                      _vm.showMap === true
                        ? "toggle-link"
                        : "toggle-link active",
                    attrs: {
                      type: "button",
                      "aria-pressed": _vm.showMap === true
                    },
                    on: {
                      click: function($event) {
                        _vm.showMap = true
                      }
                    }
                  },
                  [_vm._v("Map")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class:
                      _vm.showMap === false
                        ? "toggle-link"
                        : "toggle-link active",
                    attrs: {
                      type: "button",
                      "aria-pressed": _vm.showMap === false,
                      id: "list-link"
                    },
                    on: {
                      click: function($event) {
                        _vm.showMap = false
                      }
                    }
                  },
                  [_vm._v("List")]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "gmap-map",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showMap,
                  expression: "showMap"
                }
              ],
              attrs: {
                center: _vm.mapCenter,
                zoom: _vm.zoomLevel,
                options: _vm.mapStyles,
                id: "vue-map-container",
                "aria-label": "Map of food assistance locations"
              }
            },
            [
              _vm._l(_vm.filteredItems, function(item) {
                return _c("gmap-marker", {
                  key: item.location_name,
                  attrs: {
                    position: item,
                    icon: item.icon,
                    options: _vm.shapeOptions
                  },
                  on: {
                    click: function(e) {
                      return _vm.shapeClick(item, e)
                    }
                  }
                })
              }),
              _vm._v(" "),
              _c(
                "gmap-info-window",
                {
                  attrs: {
                    opened: _vm.selectedInfoWindowPosition !== null,
                    position: _vm.selectedInfoWindowPosition
                  },
                  on: { closeclick: _vm.infoWindowCloseClick }
                },
                _vm._l(_vm.selectedItem.items, function(selected, index) {
                  return _c("div", { key: index, staticClass: "info-window" }, [
                    _c("h3", { staticClass: "info-window-header" }, [
                      _vm.getLocation(selected)
                        ? _c("b", [_vm._v(_vm._s(_vm.getLocation(selected)))])
                        : _c("b", [_vm._v("Food assistance location")]),
                      _c("span", {
                        staticClass: "box",
                        class: selected["color"],
                        staticStyle: { float: "left" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(selected["Location address"]))]),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", [
                      _c("b", [_vm._v("Hours:")]),
                      _vm._v(
                        " " +
                          _vm._s(selected["Day"]) +
                          _vm._s(selected["Times"])
                      )
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    selected["Website"] && selected["Website"] != "N/A"
                      ? _c("span", [
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href: selected["Website"]
                              }
                            },
                            [_vm._v("Website")]
                          ),
                          _c("br")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", [
                      _c("b", [_vm._v("Contact Name:")]),
                      _vm._v(" " + _vm._s(selected["Name"] || "N/A")),
                      _c("br")
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _c("b", [_vm._v("Contact Email:")]),
                      _vm._v(" " + _vm._s(selected["Email"] || "N/A")),
                      _c("br")
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _c("b", [_vm._v("Contact Phone:")]),
                      _vm._v(" " + _vm._s(selected["Phone"] || "N/A")),
                      _c("br")
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _c("b", [_vm._v("Info:")]),
                      _vm._v(" " + _vm._s(selected["Description"] || "N/A"))
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", [
                      _c("b", [_vm._v("Eligibility Requirements:")]),
                      _vm._v(
                        " " +
                          _vm._s(selected["Eligibility requirements"] || "N/A")
                      )
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", [
                      _c("b", [_vm._v("Registration Contact:")]),
                      _vm._v(
                        " " + _vm._s(selected["Registration Contact"] || "N/A")
                      )
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", [
                      _c("b", [_vm._v("Languages Spoken other than English:")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            selected["Languages Spoken other than English"] ||
                              "N/A"
                          )
                      )
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", [
                      _c("b", [_vm._v("Metro:")]),
                      _vm._v(" " + _vm._s(selected["Metro"] || "N/A")),
                      _c("br")
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _c("b", [_vm._v("Bus:")]),
                      _vm._v(" " + _vm._s(selected["Bus"] || "N/A")),
                      _c("br")
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _c("br")
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _vm.selectedCoordinates
                ? _c("gmap-marker", {
                    attrs: { position: _vm.selectedCoordinates, radius: 24 }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.civicAssocationsSelected
                ? _c("gmap-polygon", {
                    attrs: {
                      path: _vm.civicAssocationsSelected.paths,
                      options: _vm.locationOptions
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedCoordinates && _vm.radiusSelected
                ? _c("GmapCircle", {
                    attrs: {
                      center: _vm.selectedCoordinates,
                      radius: _vm.radiusSelected * 1609,
                      visible: true,
                      options: {
                        fillColor: "blue",
                        fillOpacity: 0.1,
                        strokeWeight: 0.7,
                        strokeColor: "blue"
                      }
                    }
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.showMap,
                  expression: "!showMap"
                }
              ],
              staticClass: "list-pane"
            },
            _vm._l(_vm.filteredItems, function(filterItem, index) {
              return _c(
                "div",
                { key: index, staticClass: "project" },
                _vm._l(filterItem.items, function(item, index) {
                  return _c("div", { key: index }, [
                    _c("div", { staticClass: "row" }, [
                      _c("h3", { staticClass: "h3-list" }, [
                        _vm.getLocation(item)
                          ? _c("b", [_vm._v(_vm._s(_vm.getLocation(item)))])
                          : _c("b", [_vm._v("Food assistance location")]),
                        _c("span", {
                          staticClass: "box",
                          class: item["color"],
                          staticStyle: { float: "left" }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "no-vertical-margin" }, [
                      _c("span", [_vm._v(_vm._s(item["Location address"]))]),
                      _c("br"),
                      _vm._v(" "),
                      item["Day"]
                        ? _c("span", [
                            _c("b", [_vm._v("Hours:")]),
                            _vm._v(
                              " " +
                                _vm._s(item["Day"]) +
                                " " +
                                _vm._s(item["Times"])
                            )
                          ])
                        : _vm._e(),
                      _c("br"),
                      _vm._v(" "),
                      item["Website"] && item["Website"] != "N/A"
                        ? _c("span", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  target: "_blank",
                                  href: item["Website"]
                                }
                              },
                              [_vm._v("Website")]
                            ),
                            _c("br")
                          ])
                        : _vm._e()
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("p", { staticClass: "no-vertical-margin" }, [
                      _c("span", [
                        _c("b", [_vm._v("Contact Name:")]),
                        _vm._v(" " + _vm._s(item["Name"] || "N/A")),
                        _c("br")
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _c("b", [_vm._v("Contact Email:")]),
                        _vm._v(" " + _vm._s(item["Email"] || "N/A")),
                        _c("br")
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _c("b", [_vm._v("Contact Phone:")]),
                        _vm._v(" " + _vm._s(item["Phone"] || "N/A")),
                        _c("br")
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _c("b", [_vm._v("Info:")]),
                        _vm._v(" " + _vm._s(item["Description"] || "N/A"))
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", [
                        _c("b", [_vm._v("Eligibility Requirements:")]),
                        _vm._v(
                          " " +
                            _vm._s(item["Eligibility requirements"] || "N/A")
                        )
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", [
                        _c("b", [_vm._v("Registration Contact:")]),
                        _vm._v(
                          " " + _vm._s(item["Registration Contact"] || "N/A")
                        )
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", [
                        _c("b", [
                          _vm._v("Languages Spoken other than English:")
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              item["Languages Spoken other than English"] ||
                                "N/A"
                            )
                        )
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", [
                        _c("b", [_vm._v("Metro:")]),
                        _vm._v(" " + _vm._s(item["Metro"] || "N/A")),
                        _c("br")
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _c("b", [_vm._v("Bus:")]),
                        _vm._v(" " + _vm._s(item["Bus"] || "N/A")),
                        _c("br")
                      ])
                    ]),
                    _c("br")
                  ])
                }),
                0
              )
            }),
            0
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "blurb" } }, [
      _c("p", [
        _vm._v(
          "\n             Arlington has many food assistance resources available to ensure that any resident who needs help can get the food they need to feed themselves and their families. \n             This map shows the locations of food pantries, food distributions, and meal programs. For information on additional food assistance resources, please call 703-228-1300 or go to the\n             "
        ),
        _c(
          "a",
          {
            attrs: {
              href:
                "https://www.arlingtonva.us/Government/Departments/DHS/Food-Assistance"
            }
          },
          [_vm._v("Arlington County food assistance resources website")]
        ),
        _vm._v(".\n            Contact "),
        _c("a", { attrs: { href: "mailto:foodassistance@arlingtonva.us" } }, [
          _vm._v("foodassistance@arlingtonva.us")
        ]),
        _vm._v(" with any questions about the content of this map.\n          ")
      ]),
      _vm._v(" "),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "tooltip" }, [
      _vm._v(" Food Pantry\n                            "),
      _c("span", { staticClass: "box blue" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "tooltip" }, [
      _vm._v(" School Meals\n                            "),
      _c("span", { staticClass: "box red" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "tooltip" }, [
      _vm._v(" Prepared Meals\n                            "),
      _c("span", { staticClass: "box green" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "tooltip" }, [
      _vm._v(" Discount Groceries\n                            "),
      _c("span", { staticClass: "box purple" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "tooltip" }, [
      _vm._v(" Restricted access\n                              "),
      _c("span", { staticClass: "tooltiptext" }, [
        _vm._v("Only members of these communities")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "tooltip" }, [
      _vm._v(" Children\n                              "),
      _c("span", { staticClass: "tooltiptext" }, [
        _vm._v("For Children or Families with Children")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "tooltip" }, [
      _vm._v("  Seniors\n                              "),
      _c("span", { staticClass: "tooltiptext" }, [_vm._v("For Seniors only")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0765a2ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0765a2ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/foodResources/foodResources.vue
// module id = tfje
// module chunks = 1